import { render, staticRenderFns } from "./PokerTable.vue?vue&type=template&id=46f7d694&"
import script from "./PokerTable.vue?vue&type=script&lang=ts&"
export * from "./PokerTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports